export default "__VITE_ASSET__CtqMBx6P__"